import React from "react";
import { Title } from "../Title";
import subtitleIcon from "../../assets/svg/send.svg";
import "./style.css";
import EventBanner1 from "./Images/event-01.png";
import EventBanner2 from "./Images/event-02.png";
import { EventCard } from "./EventCard";

export const TourDates = ({ className, content }) => {
  const eventBase = content.events[0];
  const eventsObj = [
    EventBanner1,
    EventBanner1,
    EventBanner1,
    EventBanner2,
    EventBanner2,
    EventBanner2,
  ].map((src) => ({
    ...eventBase,
    src,
    link: "#",
  }));
  return (
    <section
      id="tourDates"
      className={`tourDates position-relative container ${className}`}
    >
      <Title
        title={content.sections.tour.title}
        subtitle={content.sections.tour.subtitle}
        icon={subtitleIcon}
      />

      <div className="eventsDates row">
        {eventsObj.map((item, index) => (
          <div className="event__item col-12" key={index}>
            <EventCard
              month={item.month}
              day={item.day}
              weekday={item.weekday}
              title={item.title}
              subtitle={item.subtitle}
              value={item.value}
              banner={item.src}
              link={item.link}
            />
          </div>
        ))}
      </div>
    </section>
  );
};
